var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('div',[_c('h2',{staticClass:"mb-5"},[_vm._v(_vm._s(_vm.$store.getters.t('대시보드')))])]),_c('DashboardHeader'),_c('v-row',{staticClass:"mt-4"},[_c('DashboardUserInfo'),_c('DashboardUsageInfo')],1),_c('DashboardRouteCard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }